module.exports = __webpack_public_path__ + "assets/img/thumb-Spintel-Content-Marketing.c4273e9e.webp";